import StatCard from '../common/StatCard'
import { extractValue, extractChangeType } from '../../utils/dashboardHelpers'

const StatCardSkeleton = () => (
  <div className="bg-white rounded-lg border border-gray-200 p-4 animate-pulse">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-lg bg-gray-200 flex-shrink-0"></div>
      <div className="flex-1">
        <div className="h-3 bg-gray-200 rounded w-20 mb-2"></div>
        <div className="h-5 bg-gray-200 rounded w-16"></div>
      </div>
    </div>
  </div>
)

const DashboardStatsCards = ({ overviewData, isLoading }) => {
  if (!overviewData && !isLoading) return null

  const statCardsData = overviewData
    ? [
        {
          icon: 'mdi:web',
          iconColor: 'blue',
          value: extractValue(overviewData.activeWebsites, 'count', 0).toString(),
          label: 'Active Websites',
          change: `${extractValue(overviewData.activeWebsites, 'change', 0)}%`,
          changeType: extractChangeType(overviewData.activeWebsites, 'positive'),
        },
        {
          icon: 'mdi:check-circle',
          iconColor: 'green',
          value: `${extractValue(overviewData.avgComplianceScore, 'score', 0)}%`,
          label: 'Avg. Compliance Score',
          change: `${extractValue(overviewData.avgComplianceScore, 'change', 0)}%`,
          changeType: extractChangeType(overviewData.avgComplianceScore, 'positive'),
        },
        {
          icon: 'mdi:alert-circle',
          iconColor: 'orange',
          value: extractValue(overviewData.issuesDetected, 'count', 0).toLocaleString(),
          label: 'Issues Detected',
          change: `${extractValue(overviewData.issuesDetected, 'change', 0)}%`,
          changeType: extractChangeType(overviewData.issuesDetected, 'negative'),
        },
        {
          icon: 'mdi:auto-fix',
          iconColor: 'cyan',
          value: extractValue(overviewData.autoFixedIssues, 'count', 0).toLocaleString(),
          label: 'Auto-Fixed Issues',
          change: `${extractValue(overviewData.autoFixedIssues, 'change', 0)}%`,
          changeType: extractChangeType(overviewData.autoFixedIssues, 'positive'),
        },
      ]
    : []

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
      {isLoading ? (
        <>
          <StatCardSkeleton />
          <StatCardSkeleton />
          <StatCardSkeleton />
          <StatCardSkeleton />
        </>
      ) : (
        statCardsData.map((stat, index) => <StatCard key={index} {...stat} />)
      )}
    </div>
  )
}

export default DashboardStatsCards
